module.exports = __webpack_public_path__ + "img/laptop-ui-2.6ac5f481.jpg";